import React, {Component, createRef} from "react";
import { connect } from "react-redux";
import FJResourcesOverLayList from "../view/FJResourcesOverLayList";
import FJResourcesOverLayMore from '../view/FJResourceOverLayMore'
import FJLocalStore from "../../../store/FJLocalStore";
import styles from '../view/FJResourcesOverLayList.module.less';
import FJConfig from "../../../config/FJConfig";
import {FJAnimationManager, FJOverlayManager, FJDynamicLogoManager} from "fj-graph";
import {FJMediaAction} from "../../../redux/action/FJRoot.action";
import $ from "jquery";
import FJDecorationOverlayStore from "../../../store/FJDecorationOverlayStore";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import OverlaySvg from "../../../icon/overlay-timeline.svg";
import FJUtil from "../../../util/FJUtil";
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";
import FJMedia from "../../../store/FJMedia";

class FJResourcesOverLayContainer extends Component{

	constructor(props) {
		super(props);

		this.state = {
			resourcesOverLayList: FJAnimationManager.allAnimations(),
			resourcesList: [],
			showType: 1, // 1 代表列表 2 代表分类详情列表
			isBackShow: false
		}

		this.allOverlayData = this._dealTextData({
			OverlayForText: FJOverlayManager.allOverlays(),
			OverlayForDecoration: FJDecorationOverlayStore.allOverlays(),
			LogoIntroOutro: FJDynamicLogoManager.allLogos(),
    });

		this.resourceViewInfo = {
			width: 140,
			height: 88,
			space: 12,
			marginBottom: 16,
		};

		this.config = {
			addIconToolTip: FJLocalStore._('add-to-timeline')
		};

		this.classes = {
			textListClasses: {
				textListBox: ''
			},
			textMoreClasses: {
				textMoreBox: ''
			},
			pageHeaderClasses: {
				headerBox: styles.more_header_text,
				seeAllBox:styles.more_animation_box,
				titleBox: styles.text_animation_box,
				moreBox: styles.more_box,
			},
			pageHeaderBackClasses: {
				headerBox: styles.more_header_text,
				backBox: styles.back_more_back,
				titleBox: styles.more_title,
				backTextBox: styles.more_desc
			},
			itemClasses: {
				resourceItem: styles.item,
				resourceItemActive: styles.item_active,
				inner: styles.inner_box,
				addBtnBox: styles.add_box,
				deleteBtnBox: '',
				addBtn: styles.add_button,
				name: '',
				link: '',
				refresh: '',
				reloadIcon: ''
			},
			scrollClasses: {
				trackVertical: '',
				trackHorizontal: '',
				thumbVertical: '', // styles.media_thumbVertical
				thumbHorizontal: '',
			},
		}
		this.list = createRef();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
	  if (this.props.isShow !== prevProps.isShow && this.props.isShow && this.state.showType === 1) {
      this.list.current.updateUI();
    }
  }

  _allTooltip = () => {
		FJUtil.allTooltip('u-tooltip-bottom', 'bottom');
	};

	_oneTooltip = (ele) => {
		FJUtil.oneTooltip(ele, 'bottom');
	};

	/**
	 * @description 返回Text列表
	 * @private
	 */
	_backElement = () => {
		this.setState({
			showType: 1,
			isBackShow: true
		})

	};

	/**
	 * 点击展开分类全部
	 * @param id
	 * @param title
	 * @private
	 */
	_elementSeeMore = (id, title) => {
		let list = this.allOverlayData[id];
		this.setState({
			resourcesList: list,
			title,
			showType: 2
		});
	};

	/**
	 * 处理 Element 数据
	 * @returns {{}}
	 * @private
	 */
	_dealTextData = (data) => {

		let {
			overlayPreviewPath,
      overlayVideoPath,
      dynamicLogoPreviewPath,
      dynamicLogoVideoPath,
      decorationOverlayPath,
			version,
		} = FJConfig;

    let __obj = {};
    let {OVERLAY, DYNAMIC_LOGO, DECORATION_OVERLAY} = FJCoreConstant;
		Object.keys(data || {}).forEach(key => {
      __obj[key] = [];
      let list = data[key];
		  switch (key) {
        case 'OverlayForText':
          __obj[key] = list.map(item => {
            return {
              type: OVERLAY,
              title: FJLocalStore._(item.localName),
              name: item.name,
              url: `${overlayVideoPath}/${item.name}.mp4?v=${version}`,
              thumbnail: `${overlayPreviewPath}/${item.name}.png?v=${version}`,
            }
          });
          break;
        case 'LogoIntroOutro':
          __obj[key] = list.map(item => {
            return {
              type: DYNAMIC_LOGO,
              title: FJLocalStore._(item.localName),
              name: item.name,
              url: `${dynamicLogoVideoPath}/${item.name}.mp4?v=${version}`,
              thumbnail: `${dynamicLogoPreviewPath}/${item.name}.png?v=${version}`,
            }
          });
          break;
        case 'OverlayForDecoration':
          __obj[key] = list.map(item => {
            return {
              type: DECORATION_OVERLAY,
              title: FJLocalStore._(item.localName),
              name: item.name,
              url: `${decorationOverlayPath}/${item.name.toLowerCase()}/preview.mp4?v=${version}`,
              thumbnail: `${decorationOverlayPath}/${item.name.toLowerCase()}/preview.png?v=${version}`,
            }
          });
          break;
        default:
      }
    });

		return __obj;
	};

  /**
   * @description 拖动资源库文件
   * @param e
   * @param data
   * @param callback
   * @private
   */
  _onMediaDrag = (e, data, callback) => {
    this.props.onMediaDrag(e, data, callback, this._getDragNodeInTimeLine, {height: 26, zIndex: 10});
  };

	/**
	 * @description 得到拖动background到时间轴的样式
	 * @param selfRect
	 * @returns {HTMLDivElement}
	 * @private
	 */
	_getDragNodeInTimeLine = (selfRect) => {
		let node = document.createElement('div');
		let child= document.createElement('div');
		let img  = document.createElement('div');
		$(img).append(OverlaySvg)
		$(child).append(img);
		$(node).append(child);
		$(child).addClass(styles.img_child_box);
		$(node).addClass(styles.item_active);
		$(node).addClass(styles.drag_other_img);
		let backgroundColor = '#FE60CF';
		let backgroundImage = 'none';
		$(node).css({
			width: selfRect.width,
			height: selfRect.height,
			backgroundColor: backgroundColor,
			backgroundPosition: 'auto',
			backgroundImage: backgroundImage,
			borderColor: 'rgba(254, 96, 207, 1)',
			borderRadius: '4px'
		});
		return node;
	};

	_render = (hasInit) => {
    let {showType, resourcesList, title} = this.state
    let {onAddClick, chooseMediaIdList} = this.props;
	  return (
	    <>
        <FJResourcesOverLayList isShow={showType === 1}
                                ref={this.list}
                                hasInit={hasInit}
                                allResources={this.allOverlayData}
                                resourceViewInfo={this.resourceViewInfo}
                                seeAllText={FJLocalStore._('see-all')}
                                config={this.config}
                                classes={this.classes}
                                onAddClick={onAddClick}
                                onMediaDrag={this._onMediaDrag}
                                seeMore={this._elementSeeMore}
                                chooseMediaIdList={chooseMediaIdList}
                                allTooltip={this._allTooltip}
                                oneTooltip={this._oneTooltip}
																isBackShow={this.state.isBackShow}
        />
        <FJResourcesOverLayMore isShow={showType === 2}
                                classes={this.classes}
                                resourceViewInfo={this.resourceViewInfo}
                                backTitle={FJLocalStore._('back')}
                                config={this.config}
                                list={resourcesList}
                                onAddClick={onAddClick}
                                onMediaDrag={this._onMediaDrag}
                                backElement={this._backElement}
                                title={FJLocalStore._(title)}
                                chooseMediaIdList={chooseMediaIdList}
                                allTooltip={this._allTooltip}
                                oneTooltip={this._oneTooltip}
        />
      </>
    );
  };

	render() {
		let {isShow, direction} = this.props
		return (
			<FJPanelAnimation active={isShow} direction={direction} render={this._render} />
		)
	}
}

const mapStateToProps = function (state) {
	return {
		chooseMediaIdList: state.media.chooseMediaIdList,
    direction: state.resource.direction,
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
		onAddClick: function (id, type) {
			dispatch(FJMediaAction.addToTimeLineAction(type, FJMedia.MediaFromType().LOCAL, id));
		},
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(FJResourcesOverLayContainer);
